import { StyledSpan } from "./CountryFlag.styled";

const CountryFlag = ({ countryCode, countryName }) => (
  <StyledSpan
    className={`fl-${countryCode}`}
    aria-label={`Flag of ${countryName}`}
  />
);

export default CountryFlag;
